/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAppointments } from 'app/shared/model/appointments.model';
import { IPatientProcedureEpisode } from 'app/shared/model/patient-procedure-episode.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IAppointmentEpisode {
  id?: string;
  expectedStartTime?: number | null;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  notes?: string | null;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof AddedByType | null;
  modifiedByType?: keyof typeof AddedByType | null;
  appointment?: IAppointments | null;
  episode?: IPatientProcedureEpisode | null;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<IAppointmentEpisode> = {
  active: false,
};
